let basePath = process.env.VUE_APP_API_URL;
let wsBasePath = process.env.VUE_APP_NOTIFICATIONS_BASE_URL;
export const path = {
  admin: {
    login: `${basePath}/admin/login`,
    loggedUser: `${basePath}/admin/logged-user`,
    logout: `${basePath}/admin/logout`,
    refreshToken: `${basePath}/admin/refresh-token`,
    resetPassword: `${basePath}/admin/reset-password`,
    changePassword: `${basePath}/admin/change-password`,
    verifyPasswordResetCode: (code) =>
      `${basePath}/admin/verify-password-reset-code/${code}`,
    passwordReset: `${basePath}/admin/password-reset`,
    shortUrl: {
      base: `${basePath}/admin/short-urls`,
      single: (uuid) => `${basePath}/admin/short-urls/${uuid}`,
    },
    identityVerifications: {
      base: `${basePath}/admin/identity-verifications`,
      single: (id) => `${basePath}/admin/identity-verifications/${id}`,
      review: (id) => `${basePath}/admin/identity-verifications/${id}/review`,
    },
    admins: {
      base: `${basePath}/admin/admins`,
      single: (id) => `${basePath}/admin/admins/${id}`,
      roles: `${basePath}/admin/admins/roles`,
    },
    users: {
      base: `${basePath}/admin/users`,
      single: (id) => `${basePath}/admin/users/${id}`,
      passwordReset: (id) => `${basePath}/admin/users/${id}/password-reset`,
      promotions: (id) => `${basePath}/admin/users/${id}/promotions`,
      roles: `${basePath}/admin/users/roles`,
      notes: (id) => `${basePath}/admin/users/${id}/notes`,
    },
    provinces: {
      base: `${basePath}/admin/provinces`,
    },
    lotteries: {
      base: `${basePath}/admin/lotteries`,
      single: (id) => `${basePath}/admin/lotteries/${id}`,
    },
    raffles: {
      base: `${basePath}/admin/raffles`,
      confirm: `${basePath}/admin/raffles/confirm`,
      single: (id) => `${basePath}/admin/raffles/${id}`,
      singleByDate: (date) => `${basePath}/admin/raffles/date/${date}`,
      assignResults: (id) => `${basePath}/admin/raffles/${id}/artpd`,
    },
    blocks: {
      base: `${basePath}/admin/blocks`,
      single: (id) => `${basePath}/admin/blocks/${id}`,
    },
    promotions: {
      base: `${basePath}/admin/promotions`,
      single: (id) => `${basePath}/admin/promotions/${id}`,
    },
    transactions: {
      base: `${basePath}/admin/transactions`,
      types: `${basePath}/admin/transactions/types`,
      origins: `${basePath}/admin/transactions/origins`,
      single: (id) => `${basePath}/admin/transactions/${id}`,
      dra: (id) => `${basePath}/admin/transactions/${id}/dra`,
      ara: (id) => `${basePath}/admin/transactions/${id}/ara`,
      recentDeposit: (id) =>
        `${basePath}/admin/transactions/${id}/recent-deposit`,
      recentWithdraw: (id) =>
        `${basePath}/admin/transactions/${id}/recent-withdraw`,
      reject: (id) => `${basePath}/admin/transactions/${id}/reject`,
      approve: (id) => `${basePath}/admin/transactions/${id}/approve`,
      review: (id) => `${basePath}/admin/transactions/${id}/review`,
      generateUdCommission: (id) =>
        `${basePath}/admin/transactions/${id}/generate-ud-commission`,
      paywallLink: `${basePath}/admin/transactions/paywall-link`,
      moneygrator: `${basePath}/admin/transactions/moneygrator-link`,
      chargemoney: `${basePath}/admin/transactions/chargemoney-link`,
      skyChain: `${basePath}/admin/transactions/skychain-link`,
      paycombatLink: `${basePath}/admin/transactions/paycombat-link`,
      matrevicLink: `${basePath}/admin/transactions/matrevic-link`,
    },
    commissions: {
      report: `${basePath}/admin/commissions/report`,
      paid: `${basePath}/admin/commissions/paid`,
    },
    orders: {
      base: `${basePath}/admin/orders`,
      single: (id) => `${basePath}/admin/orders/${id}`,
    },
    systemConfig: {
      smtp: {
        base: `${basePath}/admin/smtp-configuration`,
        single: (id) => `${basePath}/admin/smtp-configuration/${id}`,
        sendTestEmail: `${basePath}/admin/smtp-configuration/send-test-email`,
      },
      craueConfig: {
        base: `${basePath}/admin/craue-configuration`,
        single: (name) => `${basePath}/admin/craue-configuration/${name}`,
        banksAccounts: `${basePath}/admin/craue-configuration/banks-accounts`,
        banks: `${basePath}/admin/craue-configuration/banks`,
        countries: `${basePath}/admin/craue-configuration/countries`,
        policiesAndTerms: `${basePath}/admin/craue-configuration/policies-terms`,
        welcomePage: `${basePath}/admin/craue-configuration/welcome-page`,
        creditCardPaymentClients: `${basePath}/admin/craue-configuration/credit-card-payment-clients`,
        paymentClients: `${basePath}/admin/craue-configuration/payment-clients`,
        depositAccounts: `${basePath}/admin/craue-configuration/deposit-accounts`,
        timezones: `${basePath}/admin/craue-configuration/timezones`,
      },
    },
    commissionProfiles: {
      base: `${basePath}/admin/commission-profiles`,
      single: (id) => `${basePath}/admin/commission-profiles/${id}`,
    },
    transactionProfiles: {
      base: `${basePath}/admin/transaction-profiles`,
      single: (id) => `${basePath}/admin/transaction-profiles/${id}`,
    },
    balanceMovements: {
      base: `${basePath}/admin/balance-movements`,
      regularization: `${basePath}/admin/balance-movements/regularization`,
      regularize: `${basePath}/admin/balance-movements/regularize`,
    },
    reports: {
      monitoring: `${basePath}/admin/reports/monitoring`,
    },
    lotteryClosingSchedule: {
      base: `${basePath}/admin/lotteries-closing-schedules`,
      single: (id) => `${basePath}/admin/lotteries-closing-schedules/${id}`,
    },
    messaging: {
      notifications: {
        base: `${wsBasePath}/admin/notifications`,
        single: (id) => `${wsBasePath}/admin/notifications/${id}`,
        send: `${basePath}/admin/notifications/send`,
      },
    },
    depositAccountGroups: {
      base: `${basePath}/admin/deposit-account-groups`,
      single: (id) => `${basePath}/admin/deposit-account-groups/${id}`,
    },
    promotionRaffles: {
      base: `${basePath}/admin/promotion-raffles`,
      single: (id) => `${basePath}/admin/promotion-raffles/${id}`,
      tickets: (id) => `${basePath}/admin/promotion-raffles/${id}/tickets`,
      pay: (id) => `${basePath}/admin/promotion-raffles/${id}/pay`,
    },
    scheduledPromotionRaffles: {
      base: `${basePath}/admin/scheduled-promotion-raffles`,
      single: (id) => `${basePath}/admin/scheduled-promotion-raffles/${id}`,
    },
    ads: {
      base: `${basePath}/admin/ads`,
      single: (id) => `${basePath}/admin/ads/${id}`,
    },
    workingHours: {
      base: `${basePath}/admin/working-hours`,
      single: (id) => `${basePath}/admin/working-hours/${id}`,
    },
    responsibleGaming: {
      remove: `${basePath}/admin/responsible-gaming/remove`,
    },
  },
  client: {
    vor: `${basePath}/vor`,
    validateRecaptcha: `${basePath}/validate-recaptcha`,
    verifyPhone: `${basePath}/verify-phone`,
    isVerifyPhone: `${basePath}/is-verify-phone`,
    login: `${basePath}/login`,
    loggedUser: `${basePath}/logged-user`,
    balance: `${basePath}/balance`,
    logout: `${basePath}/logout`,
    refreshToken: `${basePath}/refresh-token`,
    requestPasswordReset: `${basePath}/request-password-reset`,
    myReferrals: `${basePath}/my-referrals`,
    commissionProfile: `${basePath}/commission-profile`,
    commissionsPending: `${basePath}/commissions/pending`,
    accountByPhone: (phone) => `${basePath}/account-by-phone/${phone}`,
    applyPromotion: (code) => `${basePath}/promotions/${code}/apply`,
    decodeLotteries: `${basePath}/decode-lotteries`,
    notApplicableBonusIp: `${basePath}/nai`,
    accountLink: `${basePath}/account-link`,
    twb: `${basePath}/twb`,
    liveLotteryAuth: `${basePath}/live-lottery-auth`,
    roulettesAuth: `${basePath}/roulettes-auth`,
    homeAds: `${basePath}/home-ads`,
    bigWinners: `${basePath}/big-winners`,
    cp: `${basePath}/cp`,
    provinces: {
      base: `${basePath}/provinces`,
    },
    raffles: {
      base: (date) => `${basePath}/raffles/${date}`,
      lottery: (date, lottery) => `${basePath}/raffles/${date}/${lottery}`,
    },
    identityVerify: `${basePath}/ivr`,
    identityVerifyState: `${basePath}/ivr-state`,
    register: `${basePath}/register`,
    settings: `${basePath}/settings`,
    verifyAccount: (code) => `${basePath}/verify-account/${code}`,
    verifyPasswordResetCode: (code) =>
      `${basePath}/verify-password-reset-code/${code}`,
    passwordReset: `${basePath}/password-reset`,
    changePassword: `${basePath}/change-password`,
    contact: `${basePath}/contact`,
    problemReport: `${basePath}/problem-report`,
    mailList: {
      join: `${basePath}/mail-list/join`,
      leave: `${basePath}/mail-list/leave`,
    },
    cart: {
      base: `${basePath}/cart`,
      single: (id) => `${basePath}/cart/${id}`,
    },
    orders: {
      base: `${basePath}/orders`,
      single: (code) => `${basePath}/orders/${code}`,
      buy: `${basePath}/orders/buy`,
      userCashBalanceReport: `${basePath}/orders/reports/cash-balance`,
      share: (code) => `${basePath}/orders/${code}/share`,
      stats: `${basePath}/orders/stats`,
    },
    lotteries: {
      base: `${basePath}/lotteries`,
    },
    shortUrl: {
      base: `${basePath}/short-urls`,
      single: (uuid) => `${basePath}/short-urls/${uuid}`,
    },
    systemConfig: {
      craueConfig: {
        single: (name) => `${basePath}/craue-configuration/${name}`,
        socialNetworks: `${basePath}/craue-configuration/social-networks`,
        whatsapp: `${basePath}/craue-configuration/whatsapp`,
        cryptapi: `${basePath}/craue-configuration/cryptapi`,
        banks: `${basePath}/craue-configuration/banks`,
        policiesAndTerms: `${basePath}/craue-configuration/policies-terms`,
        welcomePage: `${basePath}/craue-configuration/welcome-page`,
        welcomePageHTML: `${basePath}/craue-configuration/welcome-page-html`,
        creditCardPaymentClient: `${basePath}/craue-configuration/credit-card-payment-client`,
        creditCardPaymentClientLinks: `${basePath}/craue-configuration/credit-card-payment-client-links`,
        htmlHeader: `${basePath}/craue-configuration/html-extra-header`,
        headersConfig: `${basePath}/craue-configuration/headers-config`,
        helperConfig: `${basePath}/craue-configuration/helper-config`,
        carouselHomePageClient: `${basePath}/craue-configuration/carousel`,
        frequentlyAskedQuestions: `${basePath}/craue-configuration/frequently-asked-questions`,
        rouletteStatus: `${basePath}/craue-configuration/roulette-status`,
        cancelTicketTimeOut: `${basePath}/craue-configuration/cancel-ticket-timeout`,
      },
    },
    transactions: {
      base: `${basePath}/transactions`,
      pa: `${basePath}/transactions/pa`,
      single: (code) => `${basePath}/transactions/${code}`,
      token: `${basePath}/transaction-token`,
      skyChain: `${basePath}/transactions/deposit/skychain`,
      moneygrator: `${basePath}/transactions/deposit/moneygrator`,
      chargemoney: `${basePath}/transactions/deposit/chargemoney`,
      matrevic: `${basePath}/transactions/deposit/matrevic`,
      paywall: `${basePath}/transactions/deposit/paywall`,
      requestCancelWithdraw: (code) =>
        `${basePath}/transactions/request/${code}`,
    },
    files: {
      base: `${basePath}/file`?.replace("api/", ""),
      single: (file) => `${basePath}/file/${file}`?.replace("api/", ""),
    },
    balanceMovements: {
      base: `${basePath}/balance-movements`,
    },
    bankAccounts: {
      base: `${basePath}/user-bank-accounts`,
      single: (id) => `${basePath}/user-bank-accounts/${id}`,
    },
    messaging: {
      notifications: {
        base: `${wsBasePath}/notifications`,
        single: (id) => `${wsBasePath}/notifications/${id}`,
        tokens: `${basePath}/notifications/tokens`,
        clientTokens: `${basePath}/notifications/client/tokens`,
      },
    },
    countries: {
      base: `${basePath}/countries`,
    },
    ads: {
      base: `${basePath}/ads`,
      viewed: (id) => `${basePath}/ads/${id}/viewed`,
      clicked: (id) => `${basePath}/ads/${id}/clicked`,
    },
    promotionRaffles: {
      base: `${basePath}/promotion-raffles`,
      tickets: (id) => `${basePath}/promotion-raffles/${id}/tickets`,
      daily: `${basePath}/promotion-raffles/daily`,
    },
    jackpot: {
      notifications: `${basePath}/jackpot/notifications`,
      markViewed: (id) => `${basePath}/jackpot/${id}/viewed`,
    },
    responsibleGaming: {
      setLimits: `${basePath}/responsible-gaming/set-limits`,
      getLimits: `${basePath}/responsible-gaming/get-limits`,
      setExclusion: `${basePath}/responsible-gaming/autoexclusion`,
    },
  },
};
